import { type ReactNode } from 'react'

import {
  DiscoverAlert,
  SecondaryButton,
  Space,
  Text,
  TextButton,
} from '@procurify/ui'

export interface IInContextPromoAlertProps {
  analyticsId: string
  badge: ReactNode
  headline: string
  body: string
  learnMoreText: string
  laterText: string
  onLearnMoreClick: () => void
  onLaterClick: () => void
}

export const InContextPromoAlert = ({
  analyticsId,
  badge,
  headline,
  body,
  learnMoreText,
  laterText,
  onLearnMoreClick,
  onLaterClick,
}: IInContextPromoAlertProps) => (
  <DiscoverAlert analyticsId={analyticsId}>
    <Space size='small'>
      <Space direction='horizontal' align='center' size='small'>
        <Text bold>{headline}</Text>
        {badge}
      </Space>

      <Text>{body}</Text>

      <Space direction='horizontal' align='center' size='large'>
        <SecondaryButton
          type='button'
          analyticsId={`${analyticsId}-learn-more`}
          onClick={onLearnMoreClick}
        >
          {learnMoreText}
        </SecondaryButton>
        <TextButton
          type='button'
          analyticsId={`${analyticsId}-later`}
          onClick={onLaterClick}
        >
          {laterText}
        </TextButton>
      </Space>
    </Space>
  </DiscoverAlert>
)

InContextPromoAlert.displayName = 'InContextPromoAlert'
